/** CasaMapa internal admin portal (partner route) — locale and currency preferences. */
export const CASAMAPA_PARTNER_PORTAL_I18N_MANIFEST = {
  market: { code: "CO" },
  i18n: {
    defaultLocale: "es-CO",
    supportedLocales: ["es-CO", "en-US"],
    defaultCurrency: "COP",
    supportedCurrencies: ["COP", "USD", "EUR"],
  },
};
